import { Link } from '@tkww/orion-web-ds-action';
import { TextBody } from '@tkww/orion-web-ds-text';
import React from 'react';
import Styles from './DetailsEmptyState.scss';

interface Props {
	breadcrumbUrl?: string;
	section: 'amenities';
}

export const DetailsEmptyState = ({ breadcrumbUrl, section }: Props) => {
	return (
		<div className={Styles.detailsEmptyState}>
			<TextBody size="sm" bold>{`No ${section} details yet`}</TextBody>
			<div className={Styles.detailsEmptyStateContent}>
				<TextBody size="md">
					Looking for the perfect match?{' '}
					<Link href={breadcrumbUrl} styleType="secondary" size="md">
						Continue browsing vendors
					</Link>
				</TextBody>
			</div>
		</div>
	);
};
